<template>
  <div class="addFeriados">
    <h1>addFeriados</h1>
    <v-textarea v-model="textarea"></v-textarea>
    <button @click="pingServer()">Ping Server</button>
  </div>
</template>

<script>
import io from "socket.io-client";
export default {
  name: "addFeriados",
  data() {
    return {
      textarea: "",

    };
  },
  created() {
    this.socket = io("https://www.contabilidadelider.com");
},
mounted() {
    this.socket.on("webHookou", data => {
      alert(data);
        this.textarea += data;
    });
},

};
</script>
